import { render, staticRenderFns } from "./StampIndexComplete.vue?vue&type=template&id=041c76d0&"
import script from "./StampIndexComplete.vue?vue&type=script&lang=js&"
export * from "./StampIndexComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports